module.exports = __webpack_public_path__ + "img/post.467625f1.svg";